<template>
  <div>
  <L1 class="SalesRecord" @bottom="page=(this.records||[]).length >= this.count?page+1 : page;loading=true">
    <template slot="slot_title">
      <!-- <button class="addBtn" @click="addProduct=true">新增不分潤商品</button> -->
      <SearchVue placeholder="搜尋" :defaultValue="searchText" @input="searchText=$event;page=1;getRecords()"/>

      <RT :color="'var(--color-checked)'" :options="['總計', '細節']" :defaultValue="displayMode" @input="displayMode=$event"/>
      <span :style="{display: 'flex', alignItems: 'center', gap: '10px'}">
      <RT :color="'var(--color-checked)'" :options="['單日', '期間']" :defaultValue="daterange" @input="daterange=$event"/>
      <DateInput v-if="daterange==='單日'" :defaultValue="dt" @input="dt=$event"/>
      <RangeInput v-else :defaultValue="range" @input="range=$event"/>
      </span>
    <div class="test" :class="totalInfo?'opened':'closed'" v-if="records">
      <div @click="totalInfo=!totalInfo" ><span><span v-if="!totalInfo">▾</span><span v-else>▴</span>凈銷</span><span>{{formatDollarInt(subtotal)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>折扣(抵用劵)</span><span>{{formatDollarInt(discount)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>銷售發票總金額(含稅)</span><span>{{formatDollarInt(total)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>稅</span><span>{{formatDollarInt(taxtotal)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>稅(內)</span><span>{{formatDollarInt(tax4)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>稅(外)</span><span>{{formatDollarInt(tax3)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>稅(合計)</span><span>{{formatDollarInt(tax1)}}</span></div>
      <div @click="totalInfo=!totalInfo" ><span>銷售發票總金額(未稅)</span><span>{{formatDollarInt(untaxed)}}</span></div>
      <template v-for="(mach, m) in machine">
      <div v-if="mach" :key="`machine-${m}`"><span>MACHINE 0{{m+1}}</span><span>{{mach}}</span></div>
      </template>
      <div @click="totalInfo=!totalInfo" ><span>總單數</span><span>{{records.length}}/{{count}}</span></div>
      <div><span>測試會員ID</span><input type="text" v-model="memberID"></div>
    </div>
    </template>
    <Table1 :rows="records" :loading="loading" colspan="13" :empty="(this.records||[]).length >= this.count?'沒有新資料了' : null">
      <template slot="slot_head">
      <th v-for="t in th" :key="`th-${t}`">{{t}}</th>
      </template>
      <template  slot-scope="{item:rec, index:i}">
        <tr :style="{border: 'none'}">
          <td v-for="t in th" :key="`td-${i}-${t}`">
            <span v-if="t==='發票起始號碼'" :style="{whiteSpace:'nowrap'}">{{rec[t] ? rec[t] : '-'}}<br>{{rec.preorderID}}</span>
            <span v-else-if="t==='交易時間'" :style="{whiteSpace:'nowrap'}" v-html="moment(rec[t]).format('YYYY-MM-DD<br>HH:mm')"></span>
            <span v-else-if="t==='發票總金額'" :class="rec['發票總金額']!==rec['總銷售淨額']?'marked':''">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='(總)發票稅額'">{{rec[t] ? formatDollarInt(rec[t]) : 0}}({{Math.round(rec['課稅別']==="0"?(rec['發票總金額']*(1-(1/1.05))):(rec['發票總金額']*0.05))}})</span>
            <span v-else-if="t==='銷售數量'"><span v-if="rec['會員編號']">[{{rec['會員編號']}}]<br></span> 品項🞩{{rec.items.length}} 共{{rec[t]}}項</span>
            <span v-else-if="t==='總銷售淨額'" @click="removeUser(rec.id)">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='折扣'">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='門票'" @click="insertUser(rec.id)">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='二消'" @click="insertUser(rec.id)">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='回饋'">{{rec[t] ? formatDollarInt(rec[t]) : 0}}</span>
            <span v-else-if="t==='型態'" :style="{whiteSpace:'nowrap'}" class="型態" :class="rec[t]">{{rec[t]}}</span>
            <span v-else-if="t==='發票聯式'" :style="{whiteSpace:'nowrap'}">{{rec[t]}} <span v-if="rec['統一編號']"><br>{{rec['統一編號']}}</span> </span>
            <span v-else>{{rec[t] ? rec[t] : '-'}}</span>
          </td>
        </tr>
        <template v-if="displayMode==='細節'">
          <tr class="detail" :style="{backgroundColor: '#f3f3f3', border: 'none'}" v-for="(item, x) in rec.items" :key="`td-${i}-detail-${x}`">
            <td></td>
            <td>{{item.productSoldSN}}</td>
            <td></td>
            <td><span class="transCategory" :class="item.transCategory">{{item.transCategory}}</span></td>
            <td colspan="2" :style="{width: '250px', textAlign: 'start'}" :class="`P${item.productID}`">{{item.productName}}</td>
            <td :style="{textAlign:'start'}">{{item.productID}} x {{item.salesQty}}</td>
            <td>{{formatDollarInt(item.salesAmounts)}}</td>
            <td></td>
            <td>{{formatDollarInt(item.singleItemInvoiceTax)}}</td>
            <td>{{item.rewardType===1? ' ✔': '-'}}</td>
            <td>{{item.rewardType===2? ' ✔': '-'}}</td>
            <td></td>
          </tr>
        </template>
      </template>
    </Table1>
  </L1>
  </div>
</template>

<script>
import SearchVue from '../../components/input/search.vue'
import Table1 from '../../components/tables/t2'
import DateInput from '../../components/input/date.vue'
import RangeInput from '../../components/input/dateRange.vue'
import L1 from '../../components/layout/L1_scroll.vue'
import { getapi, getapi2, postapi } from '../../store/fetch'
export default {
  name: 'SalesRecord',
  components: {
    L1,
    RangeInput,
    DateInput,
    Table1,
    SearchVue
  },
  data () {
    return {
      range: {
        start: null,
        end: null
      },
      memberID: null,
      loading: false,
      taxtotal: 0,
      subtotal: 0,
      page: 1,
      totalInfo: false,
      dt: this.moment().add(-1, 'day').format('YYYY-MM-DD'),
      searchText: null,
      rangeSelect: false,
      daterange: '單日',
      displayMode: '總計',
      discount: 0,
      untaxed: 0,
      tax1: 0,
      tax2: 0,
      tax4: 0,
      tax3: 0,
      records: [],
      machine: [],
      total: 0,
      count: 0,
      th: [
        '交易時間',
        '交易序號',
        '機號',
        '型態',
        '發票起始號碼',
        '發票聯式',
        '銷售數量',
        '總銷售淨額',
        '發票總金額',
        '(總)發票稅額',
        '門票',
        '二消',
        '折扣'
      ]
    }
  },
  created () {
    if (this.$route.query.search) {
      this.searchText = this.$route.query.search
    }
    if (this.$route.query.date) {
      this.dt = this.$route.query.date
    }
    this.getRecords()
  },
  watch: {
    page () {
      if (this.page !== 1) {
        this.getdata()
      }
    },
    daterange () {
      if ((this.daterange === '期間' && !this.range) || (this.daterange === '期間' && (!this.range.start || !this.range.end))) {
      } else {
        this.page = 1
        this.getRecords()
      }
    },
    range () {
      if (this.range.start && this.range.end) {
        this.page = 1
        this.getRecords()
      }
    },
    dt () {
      if (this.dt) {
        this.page = 1
        this.getRecords()
      }
    }
  },
  methods: {
    checkScrollHeight (event) {
      // console.log(event.target.offsetHeight, event.target.scrollHeight - event.target.clientHeight * 1.5, event.target.scrollTop)
      if (this.count > 0) {
        if ((event.target.scrollHeight - event.target.clientHeight * 1.5) < event.target.scrollTop) {
          // console.log('A')
          if (this.records.length < this.count) {
            this.page = this.page + 1
          }
        }
      }
    },
    async removeUser (id) {
      const ret = await postapi(`consumeRecords/${id}/removeUser`)
      if (ret) {
        const index = this.records.map(e => e.id).indexOf(ret.id)
        this.records.splice(index, 1, ret)
      }
    },
    async insertUser (id) {
      const ret = await postapi(`consumeRecords/${id}/${this.memberID}`)
      if (ret) {
        const index = this.records.map(e => e.id).indexOf(ret.id)
        this.records.splice(index, 1, ret)
      }
    },
    async getdata () {
      const dts = this.daterange === '期間' ? this.moment(this.range.start).startOf('day').toISOString() : this.moment(this.dt).startOf('day').toISOString()
      const dte = this.daterange === '期間' ? this.moment(this.range.end).endOf('day').toISOString() : this.moment(this.dt).endOf('day').toISOString()
      const records = this.page === 1 ? await getapi(`consumeRecords?page=${this.page}&dts=${dts}&dte=${dte}${this.searchText ? `&search=${this.searchText}` : ''}`) : await getapi2((`consumeRecords?page=${this.page}&dts=${dts}&dte=${dte}${this.searchText ? `&search=${this.searchText}` : ''}`))
      if (this.page === 1) {
        this.records = records.data
      } else {
        // console.log('concat', records.data)
        this.records = this.records.concat(records.data)
      }
      if (this.records.length < this.count) {
        this.page = this.page + 1
      }
      this.count = records.count
      this.total = records.total
      this.subtotal = records.subtotal
      this.taxtotal = records.taxtotal
      this.discount = records.discount
      this.untaxed = records.untaxed
      this.machine = records.machine
      this.tax1 = records.tax1
      this.tax2 = records.tax2
      this.tax3 = records.tax3
      this.tax4 = records.tax4
    },
    async getRecords () {
      if ((this.daterange === '期間' && !this.range) || (this.daterange === '期間' && (!this.range.start || !this.range.end))) {
        this.loading = false
        return false
      } else {
        await this.getdata()
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.P679900005 {
  color: var(--color-confirm);
  font-weight: 900;
}
.P649900001 {
  color: var(--color-confirm);
  font-weight: 900;
}
.test.opened {
  position: absolute;
  top: 150px;
  right: 30px;
  font-size: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &>div{
    width: 380px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  padding: 20px 50px;
  text-align: start;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  input{
    width: 120px;
    font-size: 16px;
    padding-inline: 13px;
    padding-block: 0;
    height: 35px;
    text-align: end;
  }
}
.test.closed {
  position: absolute;
  top: 24px;
  right: 30px;
  font-size: 22px;
  height: 40px;
  &>div:nth-child(1) {
    width: 280px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &>div:not(:nth-child(1)) {
    display: none;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  // padding: 10px 20px;
  height: 40px;
  padding-inline: 20px;
  display: flex;
  align-items: center;
  text-align: start;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
}
td, th {
  text-align: start;
  padding-inline: 5px;
  box-sizing: border-box;
  // padding-inline: 10px;
  &:nth-child(1) {padding-left: 50px;}
  &:nth-child(1) { width: 170px; }
  &:nth-child(2) { width: 90px; text-align: center; }
  &:nth-child(3) { width: 60px; text-align: center; }
  &:nth-child(4) { width: 120px; text-align: center; }
  &:nth-child(5) { width: 140px; text-align: center; }
  &:nth-child(6) { width: 120px; text-align: center; }
  &:nth-child(7) { width: inherit; text-align: start; padding-left: 20px; }
  &:nth-child(8) { width: 140px; text-align: end; }
  &:nth-child(9) { width: 140px; text-align: end; }
  &:nth-child(10) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(11) { width: 140px; text-align: end; padding-right: 20px;}
  &:nth-child(12) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(13) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(14) { width: 140px; text-align: end; padding-right: 20px; }
}
tr.detail {
  td {

  &:nth-child(6) { width: inherit; text-align: start; padding-left: 20px; }
  &:nth-child(7) { width: 140px; text-align: end; }
  &:nth-child(8) { width: 140px; text-align: end; }
  &:nth-child(9) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(10) { width: 140px; text-align: end; padding-right: 20px;}
  &:nth-child(11) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(12) { width: 140px; text-align: end; padding-right: 20px; }
  &:nth-child(13) { width: 140px; text-align: end; padding-right: 20px; }
  }
}
tr {
  .marked {
    color: var(--color-confirm);
    font-weight: bold;
  }
  &:not(.detail) span.型態 {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      background-color: var(--預約中);
      color: #FFFFFF;
    }
    &.預購 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
    &.訂金 {
      background-color: var(--已報到);
      color: #FFFFFF;
    }
    &.整張銷退 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
  }
  &.detail span.transCategory{
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      font-weight: bold;
      color: var(--預約中);
    }
    &.退貨 {
      font-weight: bold;
      color: var(--通知付訂);
    }
    &.訂金 {
      font-weight: bold;
      color: var(--已報到);
    }
    &.贈品 {
      font-weight: bold;
      color: var(--已取消);
    }
    &.沖訂金 {
      font-weight: bold;
      color: var(--通知付訂);
    }

  }
}
td:nth-child(8),
td:nth-child(9),
td:nth-child(10) {
  padding-inline: 15px;
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  color: var(--color-letter);
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }
}
.SalesRecord {
  padding-inline: 18px 9px!important;
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  .headtitle {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    letter-spacing: 0.15em;
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
.SalesRecord input[type=radio] {
  min-width: 120px;
  width: 120px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.SalesRecord input[type=date]{
  margin-top: 2px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  width: 215px;
  height: 36px;
  border: 1px solid var(--color-border);
  position: relative;
  padding-inline: 13px;
  box-sizing: border-box;
  &::-webkit-calendar-picker-indicator {
    background: none;
    width: 36px;
    height: 36px;
    mask-image: url(/calendar2.svg);
    position: absolute;
    color: var(--color-checked);
    top: 0;
    right: 0;
    mask-size: contain;
    background-color: var(--color-checked);
    mask-size: 22px;
    mask-repeat: no-repeat;
    mask-position: 8px 5px;
  }
}
</style>
<style lang="scss">
.SalesRecord {
  #dts-wrapper {
    width: 325px;
    height: 40px;
    .field::after {
      content: '';
      position: absolute;
      top: 2px;
      right: 2px;
      width: 36px;
      height: 36px;
      mask-size: contain;
      background-color: var(--color-checked);
      mask-size: 22px;
      mask-repeat: no-repeat;
      mask-position: 8px 6px;
      mask-image: url(/calendar2.svg);
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
  #dts-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    height: 40px!important;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: 325px!important;
  }
}
</style>
